import { Locale } from "@/enums";
import { createI18n } from "vue-i18n";

import en from "./en.json";
import sl from "./sl.json";

export enum Language {
  en = "en",
  sl = "sl",
}

export enum CategoryName {
  SLO_NAME = "nameSlovene",
  ENG_NAME = "nameEnglish",
  CITY_NAME = "cityName",
}

const messages = {
  en: en,
  sl: sl,
};

const defaultLocale = (): string => Locale.SL.toLowerCase();

const selectedLocale = (): string => {
  const locale = localStorage.getItem("locale") as string;

  if (!locale) {
    return Locale.SL.toLowerCase();
  }

  return locale.toLowerCase();
};

const getCategoryLanguageName = (): CategoryName => {
  const selectedLanguage = selectedLocale();
  return selectedLanguage === Language.en
    ? CategoryName.ENG_NAME
    : CategoryName.SLO_NAME;
};

const getLogoPath = (): string => {
  const currentLocale = selectedLocale();
  return currentLocale === Language.en
    ? require("@/assets/images/logo.svg")
    : require("@/assets/images/rium-logo.png");
};

const loadI18n = createI18n({
  legacy: false,
  locale: selectedLocale() || defaultLocale(),
  fallbackLocale: defaultLocale(),
  messages,
});

export { loadI18n, selectedLocale, getCategoryLanguageName, getLogoPath };
